// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
// COMPONENTS
import { Modal, Button, Spinner } from 'react-bootstrap';
import Select from 'react-select';
// CUSTOM COMPONENTS
// SERVICES AND HELPERS
import TeamMemberValidator from '../../../../../helpers/validators/TeamMemberValidator';
import * as jobTeamMemberService from '../../../../../services/service/jobTeamMemberService';

const JobTeamMemberModal = (props) => {
    const { showTeamMemberModal, setShowTeamMemberModal, jobId, showAlert, fetchJobTeamMembers } = props;
    const initialValues = {
        id: 0,
        userId: null,
        jobId: jobId,
        role: '',
        isFormLead: false
    }
    const [loading, setLoading] = useState(false);
    const [teamMember, setTeamMember] = useState(initialValues);
    const [userOptions, setUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [roleOptions, setRoleOptions] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);
    const [allOptions, setAllOptions] = useState([]);
    const [doesFormLeadExist, setDoesFormLeadExist] = useState(false);

    useEffect(() => {
        if (showTeamMemberModal) {
            setLoading(true);
            jobTeamMemberService.getAvailableUsersForJob(jobId).then(res => {
                setAllOptions(res.availableMembers);
                setDoesFormLeadExist(res.doesFormLeadExist)
                setUserOptions(res.availableMembers.map(x => x.user));
                setLoading(false);
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            })
        }
    }, [showTeamMemberModal]);

    useEffect(() => {
        if (selectedUser != null) {
            let user = allOptions.find(x => x.user.value == selectedUser.value);
            setRoleOptions(user.roleOptions);
        }
    }, [selectedUser])

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: teamMember,
        validationSchema: TeamMemberValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            jobTeamMemberService.saveJobTeamMember(values).then(res => {
                fetchJobTeamMembers();
                showAlert({ message: res.message, variant: 'success' });
                handleTeamMemberModalClose();
            }).catch(ex => showAlert({ message: ex.message, variant: 'error' }))
        }
    });

    const handleTeamMemberModalClose = () => {
        formik.resetForm();
        setTeamMember(initialValues);
        setShowTeamMemberModal(false);
        setSelectedUser(null);
        setSelectedRole(null);
    }

    return (
        <Modal centered size="lg" show={showTeamMemberModal} onHide={handleTeamMemberModalClose}>
            <Modal.Header closeButton>
                <Modal.Title>Add Team Member</Modal.Title>
            </Modal.Header>
            {
                loading ? <Spinner animation="border" variant="primary" className="mb-5 mt-5 align-self-center" />
                    :
                    <form className="card card-custom" onSubmit={formik.handleSubmit}>
                        <Modal.Body>
                            <div className="form">
                                <div className="form-group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                        User
                                    </label>
                                    <div className="col-lg-9 col-xl-9">
                                        <Select
                                            value={selectedUser}
                                            options={userOptions}
                                            onChange={selectedOption => {
                                                setSelectedRole(null);
                                                setSelectedUser(selectedOption);
                                                formik.setFieldValue("userId", selectedOption.value);
                                            }}
                                            name="userId"
                                            placeholder="Select an user"
                                        />
                                        {formik.touched.userId && formik.errors.userId ? (
                                            <div className="invalid-feedback display-block">
                                                {formik.errors.userId}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                        Role
                                    </label>
                                    <div className="col-lg-9 col-xl-9">
                                        <Select
                                            value={selectedRole}
                                            options={roleOptions}
                                            isDisabled={selectedUser === null}
                                            onChange={selectedOption => {
                                                setSelectedRole(selectedOption);
                                                formik.setFieldValue("role", selectedOption.value);
                                            }}
                                            name="role"
                                            placeholder="Select a Role"
                                        />
                                        {formik.touched.role && formik.errors.role ? (
                                            <div className="invalid-feedback display-block">
                                                {formik.errors.role}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                        Descriptive Role
                                    </label>
                                    <div className="col-lg-9 col-xl-9">
                                        <input
                                            type="text"
                                            placeholder="Describe role of the user for this job"
                                            className={`form-control form-control-lg form-control-solid`}
                                            name="additionalTitle"
                                            {...formik.getFieldProps("additionalTitle")}
                                        />
                                        {formik.touched.additionalTitle && formik.errors.additionalTitle ? (
                                            <div className="invalid-feedback display-block">
                                                {formik.errors.additionalTitle}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                {
                                    !doesFormLeadExist &&
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                            Is Form Lead?
                                        </label>
                                        <div className="col-lg-9 col-xl-9">
                                            <div className="checkbox-list mt-lg-4">
                                                <label className="checkbox checkbox-primary">
                                                    <input
                                                        checked={formik.values.isFormLead}
                                                        type="checkbox"
                                                        name="isFormLead"
                                                        {...formik.getFieldProps("isFormLead")}
                                                    />
                                                    <span></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleTeamMemberModalClose}>
                                Close
                            </Button>
                            <button
                                type="submit"
                                className="btn btn-success mr-2"
                                disabled={
                                    formik.isSubmitting || (formik.touched && !formik.isValid)
                                }
                            >
                                Add Team Member
                                {formik.isSubmitting}
                            </button>
                        </Modal.Footer>
                    </form>
            }
        </Modal>
    )
}

export default JobTeamMemberModal;